import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cloud-storage',
  templateUrl: './cloud-storage.component.html',
  styleUrls: ['./cloud-storage.component.scss']
})
export class CloudStorageComponent implements OnInit {
  pt: string = 'pt-70';
  pb: string = 'pb-20'; 
  ptb: string = 'ptb-100'; 
  section: string = 'cloud-storage'; 
  title: string = 'Consulta nuestros precios sin compromiso, Contactanos.'; 
  constructor() { }

  ngOnInit(): void {

  }

}
